import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Location } from "@angular/common";
import { MainserviceService } from './../mainservice.service';

import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})


export class UserComponent implements OnInit {

  user:any;
  leaderStats:any;
   
  constructor(
    private mainservice: MainserviceService,
    private route:ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit():void{
    this.route.paramMap.switchMap((params :ParamMap) =>
    this.mainservice.getUser(+params.get('id')))
  .subscribe( user => {
    this.user = user
    this.mainservice.getLeaderStat(this.user.user).subscribe( data =>
    this.leaderStats = data
  )
  })
  }

  goBack():void {
    this.location.back();
  }
}


// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/user/user.component.ts